import type { Side } from '../types';

/**
 * Derives which side of the marketplace an event belongs to.
 *
 * Role-first when a user is logged in; route-prefix fallback for anonymous
 * flows so pre-login participant signup pages still classify as 'participant'.
 *
 * Note: the participant role string is the legacy `'respondent'` value (the
 * role predates the participant rebrand).
 */
export function deriveSide(
  user: { roles: string[] } | null | undefined,
  pathname: string,
): Side {
  if (user?.roles.includes('respondent')) return 'participant';
  if (user?.roles.includes('researcher')) return 'researcher';
  // Strict prefix match — `/participantsX` must NOT classify as participant.
  if (pathname === '/participants' || pathname.startsWith('/participants/')) {
    return 'participant';
  }
  if (pathname === '/researchers' || pathname.startsWith('/researchers/')) {
    return 'researcher';
  }
  return 'unknown';
}
